<template>
  <div>
    <!-- 页面头部 -->
    <div id="head">
      <div style="position: relative; height: 96px">
        <!-- 菜单 -->
        <navi id="navi" />
        <!-- 用户 -->
        <div id="user">
          <!-- <el-button @click="toProfile" size="mini">{{personName}}</el-button> -->
          <div style="height: 12px"><!-- 间距 --></div>
          <a href="javascript:void()" @click="toProfile" class="profile-link">
            {{ personName }}
          </a>
          <div
            style="
              font-size: 12px;
              color: #fff;
              text-align: right;
              margin-right: 74px;
            "
          >
            {{ currentEnterprise.nameAbbr }}
          </div>
        </div>
        <!-- 面包屑 -->
        <el-breadcrumb separator="&gt;">
          <el-breadcrumb-item v-for="b in breads" :key="b">
            {{ b }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!-- 页面主体 -->
    <div id="content" v-if="contextLoaded">
      <transition name="fade">
        <router-view />
      </transition>
    </div>

    <div id="footer">
      <div style="float: left; margin-left: 10px">
        <span style="font-size: 14px; color: #cfdfd3">
          中科合肥智慧农业协同创新研究院
        </span>
        <br />
        <span style="font-size: 11px; color: #93a39f">
          Copyright © 2021-2023 All Right Reserved.
        </span>
      </div>
      <img src="./iav-logo.png" alt="中科合肥智慧农业谷" style="float: right" />
    </div>
  </div>
</template>

<script>
import navigator from '@/components/navi.js'
import Navi from '@/components/Navi.vue'
import { userInfo } from '@/api/person.js'
export default {
  name: 'Home',
  components: { Navi },
  data: function () {
    return {
      breads: ['主页'],
      contextLoaded: false,
      personName: undefined,
    }
  },
  computed: {
    currentEnterprise() {
      return this.$store.getters.currentEnterprise
    },
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler: function (val) {
        navigator.setCurrentPath(val)
        this.breads = navigator.getBreadcrumb()
      },
    },
  },
  created() {
    this.contextLoaded = true
    // userInfo(this.$store.getters.userId).then((data) => {
    //   this.personName = data.data.name
    // })
  },
  mounted() {
    userInfo(this.$store.getters.userId).then((data) => {
      this.personName = data.data.name
    })
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    toProfile() {
      const query = { from: this.$route.path }
      this.$router.push({ path: '/profile', query })
    },
  },
}
</script>

<style scoped>
#head {
  position: fixed;
  z-index: 9999;
  min-width: 1400px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}
#head #navi {
  position: absolute;
  z-index: 9999;
  left: 0;
  right: 180px;
  padding-left: 260px;
  background-image: url('./app-logo.png');
  background-position: left top;
  background-repeat: no-repeat;
}
#head #user {
  position: absolute;
  right: 0;
  height: 60px;
  width: 180px;
  background-image: url('./app-user.png');
  background-position: right top;
  background-repeat: no-repeat;
}
#head .el-breadcrumb {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 8888;
  text-align: left;
  font-size: 13px;
  line-height: 30px;
  color: #6f6f6f;
  background-color: #fff; /*#d5f4e5; */
}
#content {
  /* margin-left: 210px; */
  padding: 0 5px 0 5px;
  min-height: 480px;
  /* width: 1400px; */
  margin: 96px auto 60px;
}

#footer {
  position: fixed;
  z-index: 9999;
  width: 100%;
  bottom: 0;
  height: 48px;
  background-color: #095933;
  box-sizing: border-box;
  padding: 6px;
}
.profile-link {
  display: block;
  color: #fff;
  line-height: 24px;
  text-decoration: none;
  margin-right: 75px;
  text-align: right;
}
.profile-link:hover {
  color: #409eff;
}
</style>

<style>
textarea {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  padding: 0 8px 0 8px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue